import { useContext } from 'react'

import { InputWithLabel } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'

import * as Styles from './styles'

const UnitCostFilter = ({ valueGte, onChangeGte, valueLte, onChangeLte }) => {
  const { info } = useContext(AppContext)

  return (
    <Styles.Container>
      <InputWithLabel
        label="Min"
        fullWidth
        endAdornment={info.selectedStore.currency}
        value={valueGte}
        onChange={e => onChangeGte(e.target.value)}
      />
      <span>-</span>
      <InputWithLabel
        label="Max"
        fullWidth
        endAdornment={info.selectedStore.currency}
        value={valueLte}
        onChange={e => onChangeLte(e.target.value)}
      />
    </Styles.Container>
  )
}

export default UnitCostFilter
